export default __webpack_public_path__ + "static/media/35_photo.46ead1a3.jpg";